<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-17 11:52:42
 * @LastEditTime: 2024-03-08 15:38:33
 * @Description:
 * @FilePath: \website\src\pages\news\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-carousel class="swiper" height="488px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img width="100%" :src="item" alt="" />
            </el-carousel-item>
        </el-carousel>
        <SubMenu
            class="submenu"
            :menuList="menuList"
            @anchorTo="$anchorTo"
        ></SubMenu>
        <!-- 产业动态 -->
        <div class="report" id="news1">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/news-report-topic.png"
            ></Topic>
            <el-row :gutter="30" style="margin: auto 12px">
                <el-col
                    :span="8"
                    v-for="(item, index) in reportList"
                    :key="index"
                >
                    <el-image
                        @click="$router.push({ name: 'content', params: item })"
                        :src="item.cover"
                        fit="cover"
                    ></el-image>
                    <div class="title">{{ item.title }}</div>
                    <div class="date">{{ item.newsDate }}</div>
                </el-col>
            </el-row>
        </div>
        <!-- 涉农政策 -->
        <div class="policy" id="news2">
            <Topic
                topicBg="http://wwwadm.tudouec.com/profile/resource/www_img/news-policy-topic.png"
            ></Topic>
            <el-row :gutter="30" style="margin: auto 12px">
                <el-col
                    :span="8"
                    v-for="(item, index) in policyList"
                    :key="index"
                    @click="$router.push({ name: 'content', params: item })"
                >
                    <div
                        @click="$router.push({ name: 'content', params: item })"
                    >
                        <el-image :src="item.cover" fit="cover"></el-image>
                        <div class="title">{{ item.title }}</div>
                        <div class="date">{{ item.newsDate }}</div>
                    </div>
                </el-col>
            </el-row>
            <!-- <div class="arrow">
                <LoadMore arrow="bottom"></LoadMore>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            bannerList: [
                "http://wwwadm.tudouec.com/profile/resource/www_img/banner-news.png",
            ],
            menuList: [
                { name: "产业动态", anchorId: "news1" },
                { name: "涉农政策", anchorId: "news2" },
                // { name: "服务案例", anchorId: "news3" },
            ],
            reportList: [],
            policyList: [],
        };
    },
    mounted() {
        this.getNewsList("dynamics");
        this.getNewsList("policy");
    },
    methods: {
        // 获取行业资讯
        getNewsList(type) {
            let that = this;
            let reqData = {
                type: type,
                isAsc: "desc",
                orderByColumn: "newsDate",
            };
            that.$api.getNewsList(reqData).then((res) => {
                if (type == "dynamics") {
                    this.reportList = res.rows;
                }
                if (type == "policy") {
                    this.policyList = res.rows;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/ .swiper {
    .el-carousel__indicators--horizontal {
        left: 360px;
        bottom: 15%;
    }
}
.report,
.policy,
.case {
    @extend .topic;
    margin-top: 64px;

    .el-image {
        width: 100%;
        height: 220px;
    }

    .title {
        font-size: $font-size-m;
        font-weight: 600;
        color: $color-title;
        line-height: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .arrow {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 24px 0 104px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue